module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Box-d82d3acaa22557084116ae71232821d5.svg";